import { createSelector } from '@reduxjs/toolkit';

import { getAllRelativeGeometries } from '@paragon/relative-geometry';

import { getActiveComponent } from './getActiveComponentSelector';

/**
 * Selects reference lines for the active component, with some invalid reference lines filtered out.
 */
export const getReferenceLinesForActiveComponent = createSelector(getActiveComponent, (component) => {
  if (component?.referenceLines == null) return null;

  const { referenceLines } = component;

  const relativeGeometryGuids = new Set(
    getAllRelativeGeometries(component).map((relativeGeometry) => relativeGeometry.guid),
  );

  const validReferenceLines = referenceLines.filter(
    (referenceLine) =>
      // The sealed version of
      // https://design.paragontruss.com/30255/0c0326eb-16bc-4c33-8f48-924e908d7151/componentDesign/0c0326eb-16bc-4c33-8f48-924e908d7151/0
      // is an example of when this doesn't hold.
      referenceLine.lineType !== 'Member' || relativeGeometryGuids.has(referenceLine.memberGeometryGuid),
  );

  return validReferenceLines.length < referenceLines.length ? validReferenceLines : referenceLines;
});
